'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    AnalyticsHistoricalDataController.$inject = ['$q', '$state', '$translate', 'analyticsService', 'iotService', 'measurementsService'];
    angular.module('app.admin').component('analyticsHistoricalData', {
        require: { app: '^app' },
        template: '<style>\n\n.list-group-item {\n    padding: 6px 6px 6px 15px;\n    font-size: 1em;\n    vertical-align: bottom;\n}\n\n.list-group-item i {\n    display:none;\n    color: #aaa;\n    font-size:1.5em;\n}\n\n.list-group-item.active, \n.list-group-item.active:focus,\n.list-group-item.active:hover {\n    z-index: 2;\n    color: #555;\n    text-decoration: none;\n    background-color: #f0f0f0;\n    border: 1px solid #b0b0b0;\n}\n\n.list-group-item.active i, \n.list-group-item:focus i,\n.list-group-item:hover i {\n    display: block;\n    float: right;\n}\n\n.nv-limitLinesWrap text {\n    font-weight: bold;\n}\n\n.nv-y2.nv-axis .nvd3.nv-axis .tick text,\n.nv-y2.nv-axis .nvd3.nv-axis .nv-axisMaxMin text {\n    font-size: 11px;\n    font-weight: 300;\n}\n\n</style><div style="padding: 2em 0em;"><div class="container-fluid" translate-namespace="iot"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot" translate>.Analytics historical data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-mg-3 col-lg-3"><aside class="well" style="background-color: white;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="btn-group btn-group-justified" style="margin-bottom:1em;" ng-init="mode_name_attr = (\'admin.analytics-mode.name\' | translate)"><label class="btn btn-default" uib-btn-radio="mode.id" ng-repeat="mode in $ctrl.form.modeOptions" ng-model="$ctrl.form.mode" ng-click="$ctrl.onModeChange()">{{mode[mode_name_attr]}}</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="device" class="control-label" translate>.Devices</label><ui-select id="device" ng-init="device_name_attr = (\'device.name\' | translate)" close-on-select="true" search-enabled="true" ng-model="$ctrl.form.device" data-on-select="$ctrl.onDeviceChange($item)"><ui-select-match>{{$select.selected[device_name_attr]}} - ({{$select.selected.gateway.name}})</ui-select-match><ui-select-choices group-by="$ctrl.groupDevicesByGateway" data-repeat="o in ($ctrl.deviceOptions | orderBy:device_name_attr | filter: $select.search) track by o.id"><span data-ng-bind="o[device_name_attr]"></span></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-12"><div class="form-group"><label for="date-range" class="control-label" translate>.Date</label><p class="input-group input-group-sm"><input type="text" class="form-control" uib-datepicker-popup="{{$ctrl.uiConfig.datePicker.format}}" ng-model="$ctrl.form.date" is-open="$ctrl.uiConfig.datePicker.isOpen" datepicker-options="$ctrl.uiConfig.datePicker.options" ng-required="true" clear-text="{{$ctrl.translations[\'datePicker.Clear\']}}" current-text="{{$ctrl.translations[\'datePicker.Today\']}}" close-text="{{$ctrl.translations[\'datePicker.Close\']}}" ng-change="$ctrl.onDateRangeChange()"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.datePicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-12"><div class="form-group"><label for="modality" class="control-label" translate>.Modality</label><select id="modality" class="form-control input-sm hidden-lg" ng-model="$ctrl.form.modality" ng-options="o as o[modality_name_attr] for o in $ctrl.modalityOptions | filter:$ctrl.filterModalitiesByDevice($ctrl.form.device) | orderBy:(modality_name_attr) track by o.slug" ng-change="$ctrl.onModalityChange()"></select><div class="list-group visible-lg-block" ng-init="modality_name_attr = (\'modality.name\' | translate)"><a ng-repeat="o in $ctrl.modalityOptions | filter:$ctrl.filterModalitiesByDevice($ctrl.form.device) | orderBy:(modality_name_attr)" ng-change="$ctrl.onModalityChange()" class="list-group-item" ng-model="$ctrl.form.modality" uib-btn-radio="o">{{o[modality_name_attr]}} <i class="fa fa-chevron-right" aria-hidden="true"></i></a></div></div></div></div></aside></div><div class="col-xs-12 col-sm-12 col-mg-12 col-lg-9"><div class="panel panel-default" style="padding-top:1em;padding-bottom:1em;"><h4 class="title text-center">{{$ctrl.title}}</h4><div class="subtitle text-center">{{$ctrl.subtitle}}</div><nvd3 class="nvd3-chart" options="$ctrl.uiConfig.lineChart.options" config="$ctrl.uiConfig.lineChart.config" data="$ctrl.chart"></nvd3></div></div></div></div></div>',
        controller: AnalyticsHistoricalDataController,
        controllerAs: '$ctrl'
    });

    function AnalyticsHistoricalDataController($q, $state, $translate, analyticsService, iotService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.form = new FormModel();
            $ctrl.uiConfig = new UiConfig($ctrl.form, measurementsService);

            $q.all({
                gateways: iotService.getGateways(true),
                modalities: iotService.getModalities(),
                alertLevels: analyticsService.getAlertLevels(),
                alertGroups: analyticsService.getAlertGroups(),
                translations: getTranslations()
            }).then(function (r) {
                $ctrl.modalityOptions = r.modalities;
                $ctrl.deviceOptions = _.flatMap(r.gateways, 'devices');

                $ctrl.translations = r.translations;

                $ctrl.uiConfig.lineChart.setTranslations(r.translations);
                $ctrl.uiConfig.lineChart.initialize(r.alertLevels, r.alertGroups);
                $ctrl.uiConfig.lineChart.update();

                $ctrl.form.device = _.find($ctrl.deviceOptions, { id: 34 });
                $ctrl.onDeviceChange($ctrl.form.device);
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error(error);
            });
        };

        $ctrl.groupDevicesByGateway = function (device) {
            return device.gateway.name;
        };

        $ctrl.filterModalitiesByDevice = function (device) {
            return function (modality) {
                return device.modality_ids.includes(modality.id);
            };
        };

        /**
         * 
         */
        $ctrl.$onDestroy = function () {
            // destroyTooltips();
        };

        /**
         * 
         */
        $ctrl.onDeviceChange = function (device) {
            $ctrl.form.modality = _.find($ctrl.modalityOptions, { id: device.modality_ids[0] });
            $ctrl.onModalityChange();
        };

        /**
         * 
         */
        $ctrl.onModeChange = function () {
            $ctrl.uiConfig.lineChart.update();
            // $ctrl.form.mode = _.find($ctrl.modalityOptions, { id: device.modality_ids[0] });
            // $ctrl.onModalityChange();
        };

        /**
         * 
         */
        $ctrl.onModalityChange = function () {
            $ctrl.updateChart();
        };

        /**
               * 
         */
        $ctrl.onDateRangeChange = function () {
            $ctrl.updateChart();
        };

        $ctrl.updateChart = function () {

            // hideTooltips();

            // if (!$ctrl.form.isValid) {
            //     return;
            // }

            $ctrl.chart = [];

            analyticsService.getDeviceAlerts($ctrl.form.modality, $ctrl.form.device, $ctrl.form.from, $ctrl.form.to).then(function (r) {
                $ctrl.chart.push({
                    id: 'analytics',
                    key: 'Alerts',
                    type: 'scatter',
                    values: r.alerts,
                    color: '#E65100',
                    yAxis: 2
                });
            }).catch(function (error) {
                if (error.status === 401) {
                    $state.go('login');
                }
                console.error(error);
            });

            measurementsService.getDeviceRecords($ctrl.form.modality, $ctrl.form.device, $ctrl.form.from, $ctrl.form.to, '15 minute', $ctrl.form.showOutOfRange, true).then(function (r) {

                $ctrl.uiConfig.lineChart.clearYForce1();

                var limits = [];
                if (r.modality.health_min != null) {
                    limits.push(r.modality.health_min);
                }
                if (r.modality.health_max != null) {
                    limits.push(r.modality.health_max);
                }

                $ctrl.uiConfig.lineChart.addToYForce1(limits);

                $ctrl.chart.push({
                    id: 'measurements',
                    type: 'line',
                    yAxis: 1,
                    key: r.modality.name,
                    min: r.min,
                    max: r.max,
                    healthLimits: [{ id: 'min', label: 'Health min limit', color: 'gray', value: r.modality.health_min, unit: r.modality.unit }, { id: 'max', label: 'Health max limit', color: 'gray', value: r.modality.health_max, unit: r.modality.unit }],
                    color: '#1E88E5',
                    values: r.measurements
                });
            });

            setTitle();
            setSubtitle();
        };

        /**
        * 
        */
        function getTranslations() {
            return $translate(['admin.alert.description', 'admin.alert-group.description', 'modality.name', 'compass.N', 'compass.NNE', 'compass.NE', 'compass.ENE', 'compass.E', 'compass.ESE', 'compass.SE', 'compass.SSE', 'compass.S', 'compass.SSW', 'compass.SW', 'compass.WSW', 'compass.W', 'compass.WNW', 'compass.NW', 'compass.NNW']);
        }

        /**
        * 
        * @param {*} text 
        */
        function setTitle() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var modality = $ctrl.form.modality,
                nameAttr = $ctrl.translations['modality.name'],
                title;

            title = text || modality[nameAttr] + ' - ' + modality.unit;

            $ctrl.title = title;
        }

        /**
         * 
         * @param {*} text 
         */
        function setSubtitle() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var _$ctrl$form = $ctrl.form,
                from = _$ctrl$form.from,
                to = _$ctrl$form.to,
                subtitle;


            subtitle = text || '' + from.format('DD MMM YYYY');
            $ctrl.subtitle = subtitle;
        }
    }

    /**
     * 
     */

    var FormModel = function () {
        function FormModel() {
            _classCallCheck(this, FormModel);

            this.device = undefined;
            this.date = new Date(), this.modality = undefined;
            this.showOutOfRange = true;
            this.mode = 'groups';

            this.modeOptions = [{ id: 'alerts', name: 'Alerts', name_el: 'Προειδοποιήσεις' }, { id: 'groups', name: 'Groups', name_el: 'Ομάδες ειδοποιήσεων' }];
        }

        _createClass(FormModel, [{
            key: 'initialize',
            value: function initialize() {}
        }, {
            key: 'setDefaults',
            value: function setDefaults(defaultValues) {}
        }, {
            key: 'from',
            get: function get() {
                return moment(this.date).startOf('day');
            }
        }, {
            key: 'to',
            get: function get() {
                return moment(this.date).endOf('day');
            }
        }, {
            key: 'isValid',
            get: function get() {
                // return this.isWindHistorySelected || this.countPlotPoints() <= this.maxDataPointsPerPlot;
            }
        }]);

        return FormModel;
    }();

    /**
     * 
     */


    var UiConfig = function () {
        function UiConfig(form, measurementsService) {
            var _locale;

            _classCallCheck(this, UiConfig);

            this.dataRangePicker = {
                locale: (_locale = {
                    format: 'DD/MM/YYYY'
                }, _defineProperty(_locale, 'format', 'shortDate'), _defineProperty(_locale, 'separator', ' - '), _locale)
            };

            this.datePicker = {
                isOpen: false,
                format: 'dd/MM/yyyy',
                options: {
                    maxDate: new Date()
                    // dateDisabled: true,
                },
                open: function open() {
                    this.isOpen = true;
                }
            };

            this.lineChart = new MultiChartConfig(form, measurementsService);
        }

        _createClass(UiConfig, [{
            key: 'setTranslations',
            value: function setTranslations(i18n) {
                this.lineChart.setTranslations(i18n);
            }
        }]);

        return UiConfig;
    }();

    /**
     * 
     */


    var MultiChartConfig = function () {
        function MultiChartConfig(form, measurementsService) {
            var _this = this;

            _classCallCheck(this, MultiChartConfig);

            this.form = form;
            this.toBeaufort = measurementsService.toBeaufort;
            this.toCompass = measurementsService.toCompass;

            this.config = {
                deepWatchOptions: true,
                deepWatchData: true,
                deepWatchDataDepth: 1
            };

            this.options = {
                title: { enable: false },
                subtitle: { enable: false },

                chart: {

                    id: 'linePlusScatterPlotChart',
                    type: 'linePlusScatterPlotChart',
                    useInteractiveGuideline: true,

                    height: 500,
                    duration: 250,

                    margin: { top: 40, right: 200, bottom: 40, left: 60 },

                    x: function x(d) {
                        return d.at;
                    },
                    y: this.getY(),

                    xAxis: {
                        tickFormat: this.timeFormatter(),
                        tickPadding: 20
                    },

                    yForce1: [],

                    yAxis2: {
                        tickValues: [],
                        tickFormat: function tickFormat(d) {
                            if (!isNaN(d)) {
                                switch (_this.form.mode) {
                                    case 'alerts':
                                        return _this.alertLevels[d][_this.alertDescription];
                                    case 'groups':
                                        return _this.alertGroups[d][_this.alertGroupDescription];
                                }
                            }
                        }
                    },

                    yDomain2: [0, 5],

                    interactiveLayer: {
                        tooltip: {
                            headerFormatter: this.tooltipHeaderFormatter(),
                            valueFormatter: this.tooltipValueFormatter()
                        }
                    }
                }
            };
        }

        _createClass(MultiChartConfig, [{
            key: 'initialize',
            value: function initialize(alertLevels, alertGroups) {
                this.alertLevels = _.keyBy(alertLevels, 'order');
                this.alertGroups = _.keyBy(alertGroups, 'order');
            }
        }, {
            key: 'update',
            value: function update() {
                this.onChangeMode();
            }
        }, {
            key: 'onChangeMode',
            value: function onChangeMode() {
                switch (this.form.mode) {
                    case 'alerts':
                        this.options.chart.yDomain2 = [0, 9];
                        this.options.chart.yAxis2.tickValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
                        break;
                    case 'groups':
                        this.options.chart.yDomain2 = [0, 5];
                        this.options.chart.yAxis2.tickValues = [0, 1, 2, 3, 4, 5];
                        break;
                }
            }
        }, {
            key: 'clearYForce1',
            value: function clearYForce1() {
                this.options.chart.yForce1 = [];
            }
        }, {
            key: 'addToYForce1',
            value: function addToYForce1(values) {
                this.options.chart.yForce1 = values;
            }
        }, {
            key: 'getIsDefined',
            value: function getIsDefined() {
                var self = this;
                return function (d) {
                    return self.form.modality.slug === 'wind-direction' && typeof d.dir != 'undefined' || typeof d.avg != 'undefined' || d.hasOwnProperty('alert');
                };
            }
        }, {
            key: 'getY',
            value: function getY() {
                var self = this;
                return function (d) {
                    if (d.hasOwnProperty('avg')) {
                        if (self.form.modality.slug == 'wind-direction') {
                            return d.dir;
                        }
                        return d.avg;
                    } else if (d.hasOwnProperty('alert')) {

                        switch (self.form.mode) {
                            case 'alerts':
                                return _.get(d, 'alert.order', undefined);
                            case 'groups':
                                return _.get(d, 'alert.group.order', undefined);
                        }
                    }

                    return undefined;
                };
            }
        }, {
            key: 'setTranslations',
            value: function setTranslations(i18n) {
                this.alertDescription = i18n['admin.alert.description'];
                this.alertGroupDescription = i18n['admin.alert-group.description'];

                this.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
            }
        }, {
            key: 'timeFormatter',
            value: function timeFormatter() {
                return function (d) {
                    return d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
                        return d.getHours();
                    }], ['%a %d', function (d) {
                        return d.getDay() && d.getDate() != 1;
                    }], ['%d %b', function (d) {
                        return d.getDate() != 1;
                    }], ['%B', function (d) {
                        return d.getMonth();
                    }], ['%Y', function (d) {
                        return true;
                    }]])(new Date(d));
                };

                // return d3.time.format('%H:%M');
                // return d3.currentLocale.timeFormat.multi([
                //     ['%H:%M', (d) => d.getHours()],
                //     ['%a %d', (d) => d.getDay() && d.getDate() != 1],
                //     ['%d %b', (d) => d.getDate() != 1],
                //     ['%B', (d) => d.getMonth()],
                //     ['%Y', (d) => true],
                // ]);
            }
        }, {
            key: 'tooltipHeaderFormatter',
            value: function tooltipHeaderFormatter() {
                return d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                    return true;
                }]]);
            }
        }, {
            key: 'tooltipValueFormatter',
            value: function tooltipValueFormatter() {
                var self = this;

                return function (d, i, entry) {
                    var output = '-';

                    if (entry.axis === 1) {
                        if (!isNaN(d) && d !== null) {
                            output = d3.format(',.2f')(d) + '  ' + self.form.modality.unit;
                        }
                    } else if (entry.axis === 2) {
                        if (!isNaN(d)) {
                            switch (self.form.mode) {
                                case 'alerts':
                                    return self.alertLevels[d][self.alertDescription];
                                case 'groups':
                                    return self.alertGroups[d][self.alertGroupDescription];
                            }
                        }
                    }

                    return output;
                };
            }
        }]);

        return MultiChartConfig;
    }();
})();